import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import { setChangeModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import * as resource from '../../constants/Resources'
import * as properties from '../../constants/Properties'
import OneCent from '../../images/coupures/1cent.png'
import TwoCent from '../../images/coupures/2cent.png'
import FiveCent from '../../images/coupures/5cent.png'
import TenCent from '../../images/coupures/10cent.png'
import TwentyCent from '../../images/coupures/20cent.png'
import FiftyCent from '../../images/coupures/50cent.png'
import OneEuro from '../../images/coupures/1euro.png'
import TwoEuro from '../../images/coupures/2euro.png'
import FiveEuro from '../../images/coupures/5euro.jpg'
import TenEuro from '../../images/coupures/10euro.jpg'
import TwentyEuro from '../../images/coupures/20euro.jpg'
import FiftyEuro from '../../images/coupures/50euro.jpg'
import HundredEuro from '../../images/coupures/100euro.jpg'
import TwoHundredEuro from '../../images/coupures/200euro.jpg'

class ChangeModal extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.setChangeModal(false, 0);
    }

    render() {
        let remainingChange = this.props.changeModal.amount;
        const coins = [200, 100, 50, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01];
        
        let compLine1 = [];
        let compLine2 = [];
        for(var i = 0; i < coins.length; i++) {
            let coinAmount = parseInt((remainingChange / coins[i]), 10);

            remainingChange = (remainingChange - (coinAmount * coins[i])).toFixed(2);

            if (coinAmount > 0) {
                if(coins[i] > 2)
                {
                    compLine1.push(<div key={`coupure-${coins[i]}`} className="money bill">{this.createCoupure(coins[i], coinAmount)}</div>);
                } else {
                    compLine2.push(<div key={`coupure-${coins[i]}`} className="money coin">{this.createCoupure(coins[i], coinAmount)}</div>);
                }
            }
        }; 
        
        return (
            <Modal className="changeModal"
             contentLabel="" 
             isOpen={this.props.changeModal.show}
             style={properties.changeModalStyle}
             >
                <div className="changeModal_header">
                    <div className="header_top">
                    {this.props.getTranslation(resource.CHANGE) + ": €" +Number(this.props.changeModal.amount).toFixed(2).replace('.',',')}
                    </div>
                </div>
                <div className="changeModal_content">
                    <div className="line bill">
                        {compLine1}
                    </div>
                    <div className="line coin">
                        {compLine2}
                    </div>
                </div>
                <div className="changeModal_footer">
                    <button className="btnCancel" onClick={this.closeModal}>
                        Sluiten
                    </button>
                </div>
            </Modal>
        )
    }

    createCoupure(coin, coinAmount)
    {
        let coupure = [];

        for  (var i = 0; i < coinAmount; i++)
        {
            switch (coin)
            {
                case 200:
                    coupure.push(<img src={TwoHundredEuro} alt="200 euro" />);
                    break;
                case 100:
                    coupure.push(<img src={HundredEuro} alt="100 euro" />);
                    break;
                case 50:
                    coupure.push(<img src={FiftyEuro} alt="50 euro" />);
                    break;
                case 20:
                    coupure.push(<img src={TwentyEuro} alt="20 euro" />);
                    break;
                case 10:
                    coupure.push(<img src={TenEuro} alt="10 euro" />);
                    break;
                case 5:
                    coupure.push(<img src={FiveEuro} alt="5 euro" />);
                    break;
                case 2:
                    coupure.push(<img src={TwoEuro} alt="2 euro" />);
                    break;
                case 1:
                    coupure.push(<img src={OneEuro} alt="1 euro" />);
                    break;
                case 0.5:
                    coupure.push(<img src={FiftyCent} alt="50 cent" />);
                    break;
                case 0.2:
                    coupure.push(<img src={TwentyCent} alt="20 cent" />);
                    break;
                case 0.1:
                    coupure.push(<img src={TenCent} alt="10 cent" />);
                    break;
                case 0.05:
                    coupure.push(<img src={FiveCent} alt="5 cent" />);
                    break;
                case 0.02:
                    coupure.push(<img src={TwoCent} alt="2 cent" />);
                    break;
                case 0.01:
                    coupure.push(<img src={OneCent} alt="1 cent" />);
                    break;
                default:
                    coupure.push("");
                    break;
            }
        }

        return coupure;
    }
}

ChangeModal.propTypes = {
}

function mapStateToProps(state) {
    return {
        changeModal: state.modalState.changeModal,
    }
}

export default connect(mapStateToProps, {
    setChangeModal,
    getTranslation
})(ChangeModal)


// WEBPACK FOOTER //
// src/modal/components/ChangeModal.jsx